import {
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react'
import moment from 'moment'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useNavigateNext from '../../../hooks/useNavigateNext'
import useReportingForMonth from '../../../hooks/useReportingForMonth'
import useUnits from '../../../hooks/useUnits'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { useVitalStatsState } from './hooks/useVitalStatsState'
import { VitalStatsInputFields } from './components/VitalStatsInputFields'
import { AdditionalVitalStatsFields } from './components/AdditionalVitalStatsFields'
import { VitalStatsTable } from './components/VitalStatsTable'

export const VitalStatsPage = () => {
  const isValidated = useReportMonthGuard()
  const { stats, update } = useVitalStatsState()
  const { month, year } = useReportingForMonth()
  const units = useUnits()
  const navNext = useNavigateNext()
  const purpleBubbleContent = usePurpleBubblesText('Step-5')

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        navNext()
      }}
    >
      <Stack spacing={4}>
        <MonthlyReportHeader title='Vital Statistics' />
        {purpleBubbleContent?.text && (
          <PurpleBubbleContent text={purpleBubbleContent.text} />
        )}
        <Tabs>
          <TabList>
            <Tab>
              Input for {moment.monthsShort()[month - 1]} {year}
            </Tab>
            <Tab>Vital Stats History</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Stack spacing={4}>
                <VitalStatsInputFields
                  stats={stats}
                  update={update}
                  units={units}
                />
                <AdditionalVitalStatsFields
                  stats={stats}
                  update={update}
                  units={units}
                />
              </Stack>
            </TabPanel>
            <TabPanel>
              <VitalStatsTable />
            </TabPanel>
          </TabPanels>
        </Tabs>
        <MonthlyReportNavButtons />
      </Stack>
    </form>
  )
}
